var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('splide',{attrs:{"options":_vm.options,"slides":_vm.slides}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }